import { useStyledTheme } from '@openeducation/oe-it-themes';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput, View, Platform, StyleSheet } from 'react-native';

import { OEText } from '../../../atoms';

interface FeedbackFormProps {
  nlsKeys: {
    instructions?: string;
    enterText?: string;
  };
  value: string;
  onChangeText: (value: string) => void;
}

const MAX_CHARS = 450;

export default function FeedbackForm({
  nlsKeys,
  value,
  onChangeText,
}: FeedbackFormProps) {
  const { t } = useTranslation();
  const { color } = useStyledTheme();

  return (
    <>
      {nlsKeys.instructions && (
        <OEText style={styles.instructions}>{t(nlsKeys.instructions)}</OEText>
      )}
      <View
        style={[
          styles.textAreaContainer,
          {
            backgroundColor: color.background,
            borderColor: color.border,
          },
        ]}
      >
        <TextInput
          style={[
            styles.textArea,
            {
              color: color.dark2,
              borderColor: color.transparent,
              backgroundColor: color.background,
            },
          ]}
          multiline
          value={value}
          onChangeText={onChangeText}
          maxLength={MAX_CHARS}
          placeholder={t(nlsKeys.enterText ?? '') as string}
        />
        <OEText style={[styles.charactersLeft, { color: color.dark3 }]}>
          {t('mobile.feedback.charactersLeft') +
            ' ' +
            (MAX_CHARS - value.length)}
        </OEText>
      </View>
    </>
  );
}

const styles = StyleSheet.create({
  instructions: {
    fontSize: 14,
    fontWeight: '600',
    textAlign: 'left',
    width: '100%',
  },
  textAreaContainer: {
    position: 'relative',
    width: '100%',
    marginVertical: 24,
    borderRadius: 6,
    flex: 1,
    borderWidth: 1,
    minHeight: 150,
    maxHeight: 300,
    paddingHorizontal: 16,
    paddingTop: 12,
    paddingBottom: 8,
  },
  textArea: {
    width: '100%',
    flex: 1,
    borderWidth: 0,
    fontSize: 17,
    ...Platform.select({ web: { outlineWidth: 0 } }),
  },
  charactersLeft: {
    textAlign: 'right',
    fontSize: 12,
  },
});
